(function WebModifyBookingDatesForm($, HE)
{
	"use strict";

	var form = {
		name: 'ModifyBookingDates',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

}(jQuery, window.HE || {}));